<mat-tab-group>
    <mat-tab label="Médicaments">
        <div style="">
            <app-drug-search (selected)="selectDrugPackage($event)"></app-drug-search>
        </div>
    </mat-tab>
    <mat-tab label="Magistrales">
        <div style=""></div>
    </mat-tab>
    <mat-tab label="Autres">
        <div style=""></div>
    </mat-tab>
</mat-tab-group>
